import axios from '../utils/axios';

export default function updateNTCPremiumJob(adminId, id, data) {
    return axios.post(`/admin/${adminId}/ntc-premium-jobs/${id}/update`, data)
        .then(res => res.data)
        .catch(err => err);
}
